/** @format */

import { push } from 'connected-react-router';
import { getPreOnboardedBrokerListApiService } from 'services/apiService';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from 'stateContainer/action-types';

function* workerSaga({ payload }) {
  try {
    const response = yield call(getPreOnboardedBrokerListApiService, payload);
    if (response.data.status == 'success') {
      /**
       * finally conclude the login action
       */

      yield put({
        type: actionTypes.PRE_ONBOARDED_BROKERS_LIST_SUCCESS,
        data: response.data.data,
        paging: response.data.paging
      });
    } else {
      throw new Error('Data fetch failed');
    }
  } catch (error) {
    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/login'));
    }
    yield put({ type: actionTypes.PRE_ONBOARDED_BROKERS_LIST_FAILED, error });
  }
}

export function* fetchPreOnboardedBrokersSaga() {
  yield takeLatest(
    actionTypes.PRE_ONBOARDED_BROKERS_LIST_REQUESTED,
    workerSaga
  );
}
